import { css } from 'styled-components';

export const typography = css`
    h1 {
        font-size: var(--font-size-title-lg);
        line-height: var(--line-height-title);
    }

    h2 {
        font-size: var(--font-size-title-md);
        line-height: var(--line-height-title);
    }

    h3 {
        font-size: var(--font-size-title-sm);
        line-height: var(--line-height-title);
    }

    h4 {
        font-size: var(--font-size-label-lg);
        line-height: var(--line-height-label);
    }

    h5 {
        font-size: var(--font-size-label-md);
        line-height: var(--line-height-label);

    }

    h6 {
        font-size: var(--font-size-label-sm);
        line-height: var(--line-height-label);
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: var(--font-weight-bold);
        color: var(--color-text-primary);
    }

    p {
        font-size: var(--font-size-body-md);
        line-height: var(--line-height-body);
    }

    a {
        color: var(--color-info-strong);
        cursor: pointer;
        text-underline-offset: 14%;
    }

    caption {
        font-size: var(--font-size-body-sm);
        line-height: var(--line-height-body);
        color: var(--color-text-secondary);
    }

    small {
        font-size: var(--font-size-label-md);
        line-height: var(--line-height-label);
        color: var(--color-text-secondary);
    }

    blockquote,
    dl,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    ol,
    p,
    ul {
        margin: 0;
    }

`;
